var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 158,
    viewBox: "0 0 375 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.212,
    cy: 130.596,
    rx: 160.597,
    ry: 27.1977,
    fill: "#FF437B",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.64 56.4427L23.9163 85.561C23.3094 85.7059 22.8546 86.2885 23.0066 86.871L24.0683 92.5488C24.2197 93.1305 24.8265 93.5671 25.4333 93.4222L190.157 64.4507L354.727 35.3334C355.335 35.1875 355.79 34.605 355.638 34.0233L354.576 28.3455C354.424 27.6171 353.817 27.3263 353.211 27.4713L188.64 56.4427Z",
    fill: "url(#paint0_linear_7887_21668)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4328 80.4645L7.08071 88.4716C3.89535 89.0541 0.709985 87.0157 0.103191 83.813C-0.503129 80.6104 1.62013 77.5527 4.95698 76.9702L50.3089 68.9631C53.4943 68.3805 56.6796 70.5649 57.286 73.7675C57.8928 76.8252 55.7696 79.882 52.4328 80.4645Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4321 80.4645L7.08006 88.4716C3.8947 89.0541 0.709334 87.0157 0.102539 83.813L57.2853 73.7675C57.8921 76.8252 55.7689 79.882 52.4321 80.4645Z",
    fill: "#EDEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2822 51.783L53.6471 51.4922C57.4393 50.9097 61.2309 51.7831 64.1134 53.6757C67.1469 55.7141 69.4216 58.7709 70.0285 62.4111L72.91 76.9693L68.6637 77.6978L65.7812 63.1395C65.3263 60.6644 63.8095 58.4801 61.6859 57.17C59.7142 55.7141 56.9839 55.1316 54.4059 55.5692L53.1923 55.86L52.2822 51.783Z",
    fill: "#89A3AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0679 50.328L31.5018 53.8224C29.378 54.1132 28.013 56.1516 28.4678 58.0442C28.7713 60.0827 30.743 61.3927 32.8668 60.9561L52.4334 57.6075C52.8882 57.4617 53.343 56.8791 53.1916 56.2975L52.2815 51.2013C52.13 50.6197 51.5232 50.328 51.0679 50.328Z",
    fill: "#F7487C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.696 32.4213L370.048 24.4142C373.233 23.8317 375.508 20.7749 374.901 17.5714C374.295 14.5146 371.11 12.3302 367.773 12.9128L322.421 20.9198C319.236 21.5024 316.96 24.5592 317.567 27.7627C318.174 30.9654 321.358 33.0038 324.696 32.4213Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.694 32.4213L370.046 24.4142C373.231 23.8317 375.506 20.7749 374.899 17.5714L317.565 27.7627C318.172 30.9654 321.356 33.0038 324.694 32.4213Z",
    fill: "#EDEDED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M314.079 5.48827L312.865 5.77909C309.074 6.36164 305.889 8.54504 303.765 11.4569C301.793 14.2228 300.731 17.8631 301.49 21.5024L304.22 36.0615L308.467 35.3331L305.738 20.7749C305.282 18.2998 305.889 15.6788 307.405 13.7871C308.77 11.7477 311.046 10.2927 313.624 9.8551L314.837 9.56428L314.079 5.48827Z",
    fill: "#89A3AB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.838 3.74046L334.404 0.246984C336.528 -0.0447454 338.5 1.26622 338.804 3.30377C339.259 5.19636 337.893 7.08896 335.769 7.52564L316.203 11.02C315.747 11.02 315.142 10.7292 314.99 10.1466L314.08 4.90554C313.928 4.46886 314.232 3.88632 314.838 3.74046Z",
    fill: "#F7487C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.141 127.779H230.654V84.6856C230.654 78.5711 225.345 73.6208 218.975 73.6208H212.452V58.9167C212.452 46.8336 202.138 36.7881 189.397 36.7881C176.656 36.7881 166.342 46.8336 166.342 58.9167V73.6208H159.82C153.449 73.6208 148.141 78.5711 148.141 84.6856V127.779Z",
    fill: "#F05080"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.141 127.779H160.123C160.427 99.5355 171.348 77.9895 208.509 73.6208C194.554 73.6208 180.448 73.6208 166.342 73.6208H159.82C153.449 73.6208 148.141 78.5711 148.141 84.6856V127.779Z",
    fill: "url(#paint1_linear_7887_21668)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.398 50.6201C195.314 50.6201 200.017 55.1328 200.017 60.8106C200.017 66.4884 195.314 71.002 189.398 71.002C183.483 71.002 178.781 66.4884 178.781 60.8106C178.781 55.1328 183.483 50.6201 189.398 50.6201Z",
    fill: "#344147"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.108 127.778H233.689C234.296 127.778 234.599 128.07 234.599 128.507V133.165C234.599 133.748 234.296 134.039 233.689 134.039H145.108C144.502 134.039 144.199 133.748 144.199 133.165V128.507C144.199 128.07 144.502 127.778 145.108 127.778Z",
    fill: "#344147"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.4 56.4432C191.978 56.4432 193.95 58.3367 193.95 60.811C193.95 63.2861 191.978 65.1787 189.4 65.1787C186.821 65.1787 184.85 63.2861 184.85 60.811C184.85 58.3367 186.821 56.4432 189.4 56.4432Z",
    fill: "#273137"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7887_21668",
    x1: 195.499,
    y1: 88.7733,
    x2: 187.7,
    y2: 27.5985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0745618,
    stopColor: "#C8003C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF437B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7887_21668",
    x1: 178.325,
    y1: 127.779,
    x2: 178.325,
    y2: 73.6208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8003C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/Hero.eed5071d2cfef6b28dbec25e14d874b5.svg";
export { ForwardRef as ReactComponent };